// Two-factor flag for LocalDev mode. Active only when REACT_APP_AUTH_MODE is
// the literal string "local". Any other value (or unset) falls through to the
// normal Auth0 flow.
//
// Setting this to "local" does two things:
//   1. setupProxy.js routes /entitlements, /documents, /reporting, /contacts
//      to local backend services running on their docker-compose ports,
//      avoiding CORS for cross-port API calls.
//   2. RequestService skips the redirect-to-Auth0-on-401 behavior, so a
//      backend 401 surfaces as a plain error instead of bouncing the user
//      into an Auth0 login loop they can't complete.
//
// In production builds, REACT_APP_AUTH_MODE is either unset or set to
// "auth0", so all of the above is dead code.
export const authMode = process.env.REACT_APP_AUTH_MODE;

export const isLocalAuthMode = (): boolean => authMode === "local";
